import Grid from '@mui/material/Grid';
import AlternateEmail from '../../components/fields/AlternateEmail';
import DateOfBirth from '../../components/fields/DateOfBirth';
import FirstName from '../../components/fields/FirstName';
import IdentifierNumber from '../../components/fields/IdentifierNumber';
import IdentifierType from '../../components/fields/IdentifierType';
import LastName from '../../components/fields/LastName';
import MiddleInitial from '../../components/fields/MiddleInitial';
import PhoneNumber from '../../components/fields/PhoneNumber';
import PhoneNumberExtension from '../../components/fields/PhoneNumberExtension';

const EpicCareLinkUserForm = () => {
	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={5} lg={5}>
					<FirstName />
				</Grid>
				<Grid item xs={12} sm={12} md={2} lg={2}>
					<MiddleInitial />
				</Grid>
				<Grid item xs={12} sm={12} md={5} lg={5}>
					<LastName />
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4}>
					<IdentifierType />
				</Grid>
				<Grid item xs={12} sm={12} md={8} lg={8}>
					<IdentifierNumber />
				</Grid>
				<Grid item xs={12} sm={12} md={8} lg={5}>
					<AlternateEmail />
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<DateOfBirth />
				</Grid>
				<Grid item xs={12} sm={12} md={8} lg={3}>
					<PhoneNumber />
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<PhoneNumberExtension />
				</Grid>
			</Grid>
		</>
	);
};

export default EpicCareLinkUserForm;
